<script setup lang="ts">
//startet beim laden der seite -> imports und so hier rein
</script>

<script lang="ts">
//startet nicht beim init der seite -> eigene Funktionen und so hier rein
</script>

<template>
  <div class="w-full h-full card flex flex-col justify-center">
    <h3>Template</h3>
  </div>
</template>

<style scoped>
.card { background:#111; color:#eee; padding:16px; }
</style>